export const SET_APPS = 'SET_APPS';
export const ADD_NEW_APP = 'ADD_NEW_APP';
export const REMOVE_APP = 'REMOVE_APP';
export const SET_APP_ORGANIZATIONS = 'SET_APP_ORGANIZATIONS';

// SERVER ACTIONS
export const SAGA_LOAD_APPS = 'SAGA_LOAD_APPS';
export const SAGA_CREATE_APP = 'SAGA_CREATE_APP';
export const SAGA_DELETE_APP = 'SAGA_DELETE_APP';
export const SAGA_LOAD_APP_ORGANIZATIONS = 'SAGA_LOAD_APP_ORGANIZATIONS';
export const SAGA_ADD_ORGANIZATION_TO_APP = 'SAGA_ADD_ORGANIZATION_TO_APP';
export const SAGA_REMOVE_ORGANIZATION_FROM_APP = 'SAGA_REMOVE_ORGANIZATION_FROM_APP';

export const setApps = (apps) => {
	return {
		type: SET_APPS,
		payload: {
			apps,
		}
	}
}

export const removeApp = (appId) => {
	return{
		type: REMOVE_APP,
		payload:{
			appId: appId,
		}
	}
}

export const setAppOrganizations = (appId, organizations) => {
	return {
		type: SET_APP_ORGANIZATIONS,
		payload: {
			appId,
			organizations,
		}
	}
}

export const sagaLoadApps = () => {
	return {
		type: SAGA_LOAD_APPS,
	}
}

export const sagaLoadAppOrganizations = (appId) => {
	return {
		type: SAGA_LOAD_APP_ORGANIZATIONS,
		payload: {
			appId,
		}
	}
}

export const sagaCreateApp = (app) => {
	return {
		type: SAGA_CREATE_APP,
		payload: {
			app,
		}
	}
}

export const sagaRemoveOrganizationFromApp = (appId, organizationId) => {
	return {
		type: SAGA_REMOVE_ORGANIZATION_FROM_APP,
		payload: {
			appId,
			organizationId,
		}
	}
}

export const sagaAddOrganizationToApp = (appId, organizationId) => {
	return {
		type: SAGA_ADD_ORGANIZATION_TO_APP,
		payload: {
			appId,
			organizationId,
		}
	}
}

export const sagaDeleteApp = (appId) => {
	return{
		type: SAGA_DELETE_APP,
		payload: {
			appId,
		}
	}
}

export const addNewApp = (app) => {
	return {
		type: ADD_NEW_APP,
		payload:{
			app,
		}
	}
}


// WEBPACK FOOTER //
// ./src/apps/actions.js